<template>
  <div>
    <button class="button clearfix"
            :class="[typeClass, variationClass, orientationClass]"
            :id="id"
            @click="$emit('change', $event)">
      {{label}}
    </button>
  </div>
</template>

<script>
import {
  elementable, orientationable, typeable, variationable,
} from '../mixins';

export default {
  name: 'Button',
  mixins: [
    elementable,
    orientationable,
    typeable,
    variationable,
  ],
  props: {
    label: {
      type: String,
      default: 'Button',
      required: false,
    },
  },
};
</script>
